import axios from 'axios'
const errorsHandler = require('@/services/errors')

const moduleName = 'customer-skills'

const state = {}
const getters = {}

const getHeaders = context => ({
    Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`,
})

const actions = {
    getByCustomer: async (context, payload) => {
        const url = `api/v1/${moduleName}/${payload.customerId}`

        return axios
            .get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                headers: getHeaders(context),
                'Content-Type': 'application/json',
            })
            .then(result => result.data.data)
            .catch(error => errorsHandler.errorHandler(error))
    },

    upsert: async (context, payload) => {
        const url = `api/v1/${moduleName}/${payload.customerId}/${payload.sport_master}`

        return axios
            .post(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                payload.item,
                {
                    headers: getHeaders(context),
                    'Content-Type': 'application/json',
                }
            )
            .then(result => ({
                success: true,
                result: result.data.data,
            }))
            .catch(error => errorsHandler.errorHandler(error))
    },
}

const mutations = {}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
}
